import { createAction } from '@reduxjs/toolkit'

import actionTypes from './actionTypes'

export const requestDevices = createAction(actionTypes.REQUEST_DEVICES)

export const setRequestingDevices = createAction(
  actionTypes.SET_REQUESTING_DEVICES
)

export const devicesRequestSuccessful = createAction(
  actionTypes.DEVICES_REQUEST_SUCCESSFUL
)

export const devicesRequestUnsuccessful = createAction(
  actionTypes.DEVICES_REQUEST_UNSUCCESSFUL
)

export const setDevicePage = createAction(actionTypes.SET_DEVICE_PAGE)

export const setDeviceSearchQuery = createAction(
  actionTypes.SET_DEVICE_SEARCH_QUERY
)

// Register device
export const registerDevice = createAction(
  actionTypes.REGISTER_DEVICE,
  ({ payload, onSuccess }) => ({ payload: { onSuccess, payload } })
)

export const setRegisteringDevice = createAction(
  actionTypes.SET_REGISTERING_DEVICE,
  isSaving => ({ payload: isSaving })
)

export const setRegisterDeviceError = createAction(
  actionTypes.SET_REGISTER_DEVICE_ERROR,
  error => ({ payload: error })
)

// Ship options (for vessel select in register/edit drawers)
export const requestShipOptions = createAction(actionTypes.REQUEST_SHIP_OPTIONS)

export const setRequestingShipOptions = createAction(
  actionTypes.SET_REQUESTING_SHIP_OPTIONS,
  isLoading => ({ payload: isLoading })
)

export const shipOptionsRequestSuccessful = createAction(
  actionTypes.SHIP_OPTIONS_REQUEST_SUCCESSFUL
)

export const shipOptionsRequestUnsuccessful = createAction(
  actionTypes.SHIP_OPTIONS_REQUEST_UNSUCCESSFUL
)
